import type { MouseEvent } from 'react'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { OptionsMenuActions, OptionsMenuButton } from 'tripPlanner/assistant/components/HistoryItemOptions/OptionsMenuActions'
import AssistantHistoryItemMenuAction from './AssistantHistoryItemMenuAction'

interface Props {
  closeMenu: () => void
  onBeginRename: (closeMenu: () => void) => void
  onDelete: () => void
  onDownloadPdf?: () => void
  onDownloadSpreadsheet?: () => void
}

function AssistantHistoryItemMenuActions({
  closeMenu,
  onBeginRename,
  onDelete,
  onDownloadPdf,
  onDownloadSpreadsheet,
}: Props) {
  const intl = useIntl()

  // Rename closes the menu itself, just before it focuses the inline field.
  const handleRenameClick = useCallback((event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    onBeginRename(closeMenu)
  }, [closeMenu, onBeginRename])

  return (
    <OptionsMenuActions>
      {onDownloadPdf && (
        <AssistantHistoryItemMenuAction
          label={intl.formatMessage({
            id: 'RUvxnbcR8PPPIBhJKpTI',
            defaultMessage: 'Download PDF',
            description: 'Dropdown option that downloads the selected TripPlanner chat itinerary as a PDF file',
          })}
          closeMenu={closeMenu}
          onSelect={onDownloadPdf}
        />
      )}
      {onDownloadSpreadsheet && (
        <AssistantHistoryItemMenuAction
          label={intl.formatMessage({
            id: '4Zl9l2PpVWD-rkbEWCFi',
            defaultMessage: 'Download spreadsheet',
            description: 'Dropdown option that downloads the selected TripPlanner chat itinerary as a spreadsheet file',
          })}
          closeMenu={closeMenu}
          onSelect={onDownloadSpreadsheet}
        />
      )}
      <OptionsMenuButton type="button" onClick={handleRenameClick}>
        {intl.formatMessage({
          id: 'N23Cx9-WUSWvCOAv-r_S',
          defaultMessage: 'Rename',
          description: 'Actions menu option that renames a chat from its row in the TripPlanner side navigation, the menu drawer or the offer-page chat history',
        })}
      </OptionsMenuButton>
      <AssistantHistoryItemMenuAction
        label={intl.formatMessage({
          id: 'zNyinc-C1AnYgwqNTl0b',
          defaultMessage: 'Delete',
          description: 'Actions menu option that deletes a chat from its row in the TripPlanner side navigation, the menu drawer or the offer-page chat history',
        })}
        closeMenu={closeMenu}
        onSelect={onDelete}
      />
    </OptionsMenuActions>
  )
}

export default AssistantHistoryItemMenuActions
